import React from "react";
import _ from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import { Button, VARIANT } from "@metacrm/metacrm-material-ui/dist/Button";
import { useIntl } from "react-intl";

const NotFound = ({}) => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const envEntity = process.env.REACT_APP_ENTITY;
  const isCustomDomain = Boolean(envEntity);
  return (
    <div
      className="loadingPaper"
      style={{
        background: "white",
        position: "relative",
        textAlign: "center",
      }}
    >
      <Button
        style={{ position: "absolute", top: "20px", right: "20px" }}
        variant={VARIANT.TEXT}
        onClick={() => {
          navigate("/workspace");
        }}
      >
        {formatMessage({ id: "global.btn.workSpace" })}
      </Button>

      <div>
        <img src={require("assets/img/404.svg").default} />
        <div
          style={{
            marginTop: 32,
            marginBottom: 20,
            fontSize: 36,
            fontWeight: 800,
          }}
        >
          {formatMessage({ id: "pageLost.error.title" })}
        </div>
        <div style={{ fontWeight: 500, fontSize: 18 }}>
          {formatMessage({ id: "pageLost.error.description" })}
        </div>
        <Button
          onClick={() => navigate(isCustomDomain ? "/" : "/onboarding")}
          variant={VARIANT.OUTLINED}
          style={{
            borderRadius: 5,
            marginTop: 32,
            height: 50,
          }}
        >
          <img
            src={require("assets/img/backButton.svg").default}
            style={{ marginRight: 5 }}
          />
          {formatMessage({ id: "global.btn.goHome" })}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
